import React, { useState, useEffect } from 'react';
import { Tabs, Typography } from 'antd';
import {
  DashboardOutlined,
  MedicineBoxOutlined,
  UserOutlined,
  SwapOutlined,
  TeamOutlined,
  EnvironmentOutlined,
  HistoryOutlined,
} from '@ant-design/icons';
import DashboardTab from '../components/Reconciliacion/DashboardTab';
import FarmaciasTab from '../components/Reconciliacion/FarmaciasTab';
import FarmaceuticosTab from '../components/Reconciliacion/FarmaceuticosTab';
import TransmisionesTab from '../components/Reconciliacion/TransmisionesTab';
import EmpleadosTab from '../components/Reconciliacion/EmpleadosTab';
import TrasladosTab from '../components/Reconciliacion/TrasladosTab';
import HistoricoTab from '../components/Reconciliacion/HistoricoTab';
import { getCiclos, type ReconciliacionCiclo } from '../api/reconciliacionApi';

const { Title } = Typography;

const ReconciliacionPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedRecIds, setSelectedRecIds] = useState<number[]>([]);
  const [ciclos, setCiclos] = useState<ReconciliacionCiclo[]>([]);

  useEffect(() => {
    const init = async () => {
      try {
        const data = await getCiclos();
        setCiclos(data);
        if (data.length > 0) {
          setSelectedRecIds([data[0].id]); // última (orden cronológico inverso)
        }
      } catch { /* silently fail */ }
    };
    init();
  }, []);

  const tabItems = [
    {
      key: 'dashboard',
      label: <span><DashboardOutlined /> Dashboard</span>,
      children: <DashboardTab onTabChange={setActiveTab} />,
    },
    {
      key: 'farmacias',
      label: <span><MedicineBoxOutlined /> Farmacias</span>,
      children: <FarmaciasTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'farmaceuticos',
      label: <span><UserOutlined /> Farmacéuticos</span>,
      children: <FarmaceuticosTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'transmisiones',
      label: <span><SwapOutlined /> Transmisiones</span>,
      children: <TransmisionesTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'empleados',
      label: <span><TeamOutlined /> Empleados</span>,
      children: <EmpleadosTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'traslados',
      label: <span><EnvironmentOutlined /> Traslados</span>,
      children: <TrasladosTab selectedRecIds={selectedRecIds} />,
    },
    {
      key: 'historico',
      label: <span><HistoryOutlined /> Histórico</span>,
      children: <HistoricoTab ciclos={ciclos} selectedRecIds={selectedRecIds} onSelectionChange={setSelectedRecIds} onCiclosReload={setCiclos} />,
    },
  ];

  return (
    <div style={{ padding: '0 8px' }}>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={tabItems}
        size="large"
        tabBarExtraContent={
          <div style={{ backgroundColor: '#f5f5f5', border: '1px solid #d9d9d9', borderRadius: 6, padding: '4px 16px' }}>
            <Title level={5} style={{ margin: 0, color: '#595959' }}>
              Conciliación con datos oficiales
            </Title>
          </div>
        }
        style={{ background: '#fff', padding: '8px 24px 16px', borderRadius: 8 }}
      />
    </div>
  );
};

export default ReconciliacionPage;
